import * as React from "react";

interface PageContentProps {
    className?: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export function PageContent(props: PageContentProps): JSX.Element {
    if (props.className != undefined || props.style != undefined) {
        return (
            <div className={props.className} style={props.style}>
                {props.children}
            </div>
        );
    }
    return <>{props.children}</>;
}
